module.exports = __webpack_public_path__ + "img/right-arrow.f9df8c64.svg";